<template>
    <div>
      <p class="marker-contrib">{{ amount | currency }}</p>
      <div class="marker-years">
        <div ref="item" @click="onClick($event, key)" :key="key" v-for="(f, key) in years" class="marker-year" :class="{'current-year' : key === active }">
          {{ f.year }}
        </div>
      </div>
    </div>
</template>

<script>
import currency from '@/filters/currency'

export default {
  filters: {currency},
  props: {
    funding: {
      type: Array,
      requried: true
    }
  },
  data: () => ({
    active: 0
  }),
  methods: {
    onClick (e, key) {
      e.preventDefault()
      e.stopPropagation()
      this.active = key
    }
  },
  computed: {
    amount () {
      return this.years[this.active].amount
    },
    years () {
      let funding = [].concat(this.funding)

      funding.sort((a, b) => {
        return a.year > b.year ? -1 : (a.year < b.year ? 1 : 0)
      })

      return funding
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@styles/colors/variables';
@import '~@styles/mixins/index';
@import '~@styles/mq/variables';

.marker-contrib, .marker-year {
  user-select: none;
  font-family: 'Gilroy';
}

.marker-contrib {
  font-size: 15px;
  font-style: italic;

  display: flex;
  align-items: center;

  &:before {
    content: "";
    background-image: url('/static/images/elements/cash.svg');
    background-size: contain;

    background-repeat: no-repeat;
    background-position: center;

    display: block;
    height: 16px;
    width: 20px;

    margin-right: 10px;

    transform: translateY(-1px);
  }

  &:after {
    content: "kr.";
    margin-left: 5px;
  }
}

.marker-years {
  position: absolute;
  bottom: 15px;
  right: 15px;

  @include font-size(15px, 17px);
}

.marker-year {
  color: $color-grey-x;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 5px;

  @media #{$below-breakpoint-768} {
    margin-bottom: 10px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    color: $color-grey-xx;
  }

  &.current-year {
    color: $color-red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/funding.vue